<template>
	<main class="common-main-container">
		<header>
			<h1 class="d-flex align-items-center">
				<img
					class="mr-3"
					src="../../../assets/common-icons/BackArrow.svg"
					alt=""
				/>
				Add Configuration
			</h1>
		</header>
		<body class="my-2 w-100 custom-fields-body">
			<b-container>
				<header class="d-flex align-items-center justify-content-between">
					<div class="add-res-tabs w-100 position-relative ml-2">
						<b-tabs content-class="mt-1" justified>
							<b-tab title="Opening Screen Display" active>
								<div class="selected-border">
									<!-- BIND IT HERE left-215 and left-430 and left-645 -->
								</div>
							</b-tab>
							<b-tab title="Question Behaviour"> </b-tab>
							<b-tab title="System Setup"> </b-tab>
							<b-tab title="Do’s and Dont’s"> </b-tab>
						</b-tabs>
					</div>
				</header>
				<body class="">
					<b-row class="mt-4">
						<b-col>
							<DateField :isMandatory="true" />
						</b-col>
						<b-col>
							<DateField :isMandatory="true" />
						</b-col>
						<b-col>
							<SingleSelect :optionsArray="dataDpd" :text="'Test Type'" />
						</b-col>
					</b-row>
					<b-row class="mt-4">
						<b-col>
							<RadioSelect :isMandatory="true" />
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<TextArea :rows="1" :max-rows="2" />
						</b-col>
					</b-row>
				</body>

				<footer
					class="  d-flex
                align-items-center
                justify-content-end
                w-100"
				>
					<b-button class="new-cancelBtn mr-3">
						Cancel
					</b-button>
					<b-button class="new-addBtn">
						Select Configuration
					</b-button>
				</footer>
			</b-container>
		</body>
	</main>
</template>

<script>
import SingleSelect from "../../../components/InputComponents/SingleSelect.vue";
import DateField from "../../../components/InputComponents/DateField.vue";
import RadioSelect from "../../../components/InputComponents/RadioSelect.vue";
import TextArea from "../../../components/InputComponents/TextArea.vue";
export default {
	name: "ConfigurationList",
	data() {
		return {
			loopvar: 20,
			dataDpd: [
				{ text: "abc", value: 1 },
				{ text: "xyz", value: 2 },
				{ text: "123", value: 3 },
				{ text: "456", value: 4 },
				{ text: "qwe", value: 5 },
				{ text: "abc", value: 6 },
				{ text: "xyz", value: 7 },
				{ text: "123", value: 8 },
				{ text: "456", value: 9 },
				{ text: "qwe", value: 10 },
			],
		};
	},
	components: {
		SingleSelect,
		DateField,
		RadioSelect,
		TextArea,
	},
};
</script>

<style scoped>
.add-config-overflow {
	height: calc(100vh - 275px);
	overflow: auto;
}

.custom-fields-body body {
	height: 75%;
}
</style>
